import { forwardRef, useId, type TextareaHTMLAttributes } from "react";
import { cn } from "@/lib/cn";
import { LabeledField } from "./LabeledField";

export interface TextAreaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  etiqueta: string;
  error?: string | null;
  ayuda?: string;
  filas?: number;
  contenedorClassName?: string;
}

/** Campo de texto de varias líneas. Mismas reglas que TextField: etiqueta visible, ayuda o error asociados. */
export const TextArea = forwardRef<HTMLTextAreaElement, TextAreaProps>(function TextArea(
  { etiqueta, error, ayuda, filas = 4, id, className, contenedorClassName, ...props },
  ref,
) {
  const idAuto = useId();
  const idCampo = id ?? idAuto;
  const descripcion = error ? `${idCampo}-error` : ayuda ? `${idCampo}-ayuda` : undefined;
  return (
    <LabeledField etiqueta={etiqueta} htmlFor={idCampo} error={error} ayuda={ayuda} className={contenedorClassName}>
      <textarea
        ref={ref}
        id={idCampo}
        rows={filas}
        aria-invalid={error ? true : undefined}
        aria-describedby={descripcion}
        className={cn(
          "w-full rounded-control border border-borde-fuerte bg-superficie px-3 py-2 text-texto",
          "placeholder:text-texto-suave/70 focus:border-primario focus:outline-none focus:ring-2 focus:ring-primario/25",
          "disabled:bg-superficie-2 disabled:text-texto-suave",
          error && "border-peligro focus:border-peligro focus:ring-peligro/25",
          className,
        )}
        {...props}
      />
    </LabeledField>
  );
});
